<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<div class="grid align-items-center">
  <div class="col md:col-11">
    <span class="p-input-icon-left ml-auto w-full">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        #keywordFilter
        (input)="dt1.filterGlobal([keywordFilter.value], 'contains')"
        placeholder="Cerca..." />
    </span>
  </div>
  <div class="col">
    <p-button
      styleClass="butt"
      icon="pi pi-filter-slash"
      (click)="clear(dt1)"
      pTooltip="Elimina filtri"
      tooltipPosition="top"></p-button>
  </div>
</div>
<div class="tbl max-w-full">
  <p-table
    [value]="products"
    dataKey="id"
    #dt1
    [loading]="loading"
    [(selection)]="selectedProduct"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali"
    [paginator]="true"
    [globalFilterFields]="[
      'name',
      'code_internal',
      'agreement_code',
      'integration_code',
      'brand',
      'product.related_product_category.name',
    ]"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [rowsPerPageOptions]="rowsPerPageOptions">
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th>Nome</th>
        <th>Brand</th>
        <th>Categoria</th>
        <th>Codice interno</th>
        <th>Codice fornitore</th>
        <th>Descrizione</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-p>
      <tr [ngClass]="{ 'disabled': checkIfProdIsChosen(p) || !!getDisabledReason(p) }">
        <!-- <td>
          <p-tableCheckbox [value]="p"></p-tableCheckbox>
        </td> -->
        <td *ngIf="pickerType !== 'radio'">
          <p-tableCheckbox [value]="p"></p-tableCheckbox>
        </td>
        <td *ngIf="pickerType === 'radio'">
          <p-radioButton
            [value]="p"
            [inputId]="p.id"
            name="selectedProductControl"
            [formControl]="selectedProductControl"
            [disabled]="!!getDisabledReason(p)"></p-radioButton>
        </td>
        <td>
          <div class="flex align-items-center gap-2">
            <i
              *ngIf="getDisabledReason(p)"
              class="pi pi-lock text-orange-400"></i>
            {{ p.name || '-' }}
          </div>
          <small
            *ngIf="getDisabledReason(p)"
            class="text-orange-400 block mt-1">
            {{ getDisabledReason(p) }}
          </small>
        </td>
        <td>
          {{ p.brand || '-' }}
        </td>
        <td>
          <p-chip *ngIf="p.product">{{ p.product.related_product_category?.name || '-' }}</p-chip>
          <p-chip *ngIf="!p.product">{{ p.related_product_category?.name || '-' }}</p-chip>
        </td>
        <td>
          <small>
            {{ p.code_internal || '-' }}
          </small>
        </td>
        <td>
          <small>
            {{ p.code_supplier || '-' }}
          </small>
        </td>
        <td>
          <small>
            {{ p.desc_short || '-' }}
          </small>
        </td>
      </tr>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td
            colspan="7"
            class="text-center py-2">
            Nessun risultato.
          </td>
        </tr>
      </ng-template>
    </ng-template>
  </p-table>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      icon="pi pi-times"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
